/**
 * Created by piotr.pozniak@thebeaverhead.com on 07/02/2023.
 */

const initialState = {
  collection: [],
  pagination: null,

  fetch: false,
  fetchSuccess: false,
  fetchError: null,

  delete: false,
  deleteSuccess: false,
  deleteError: null,
  deleteRecordsCount: 0,
};

export default function reducer(
  state = { ...initialState, collection: [] },
  action
) {
  switch (action.type) {
    case "QUEUE_JOBS_FETCH":
      return {
        ...state,
        fetch: true,
        fetchSuccess: false,
        fetchError: false,
        deleteSuccess: false,
      };

    case "QUEUE_JOBS_FETCH_FULFILLED":
      return {
        ...state,
        collection: action.payload.queuedJobs,
        pagination: action.payload.pagination,
        fetch: false,
        fetchSuccess: true,
      };

    case "QUEUE_JOBS_FETCH_REJECTED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: false,
        fetchError: action.payload,
      };

    case "QUEUE_JOBS_DELETE":
      return {
        ...state,
        delete: true,
        deleteSuccess: false,
        deleteError: false,
      };

    case "QUEUE_JOBS_DELETE_FULFILLED":
      return {
        ...state,
        deleteRecordsCount: action.payload.removedJobsCount,
        delete: false,
        deleteSuccess: true,
      };

    case "QUEUE_JOBS_DELETE_REJECTED":
      return {
        ...state,
        delete: false,
        deleteSuccess: false,
        deleteError: action.payload,
      };

    case "CLEAR_ERRORS":
      return {
        ...initialState,
        collection: [...state.collection],
      };

    case "QUEUE_JOBS_CLEAR":
      return {
        ...initialState,
      };

    case "USER_LOGOUT":
      return { ...initialState, collection: [] };

    default:
      return state;
  }

  return state;
}
